import React from 'react';
import style from './ModalStyles.module.css';

const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

function Timer({ time, isPaused }) {
    let timerClass = style.timeRunningOut;

    if (isPaused) {
        timerClass = style.paused;
    } else if (time > 10) {
        timerClass = style.plentyOfTimeLeft;
    } else if (time === 0) {
        timerClass = style.timeOver;
    }

    return (
        <div className="bg-cleanSlate px-4 rounded-lg top-[-20px] my-6">
            <p className={`text-[60px] ${timerClass}`}>
                {formatTime(time)}
            </p>
        </div>
    );
}

export default Timer;
